// extracted by mini-css-extract-plugin
export default {"container":"DashBoardTemplate_container__ho3PB"};